import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { ButtonComponent } from '@lyceo/shared/ui';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSpinner, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FieldState } from '@angular/forms/signals';

@Component({
  selector: 'homi-form-submit-button',
  templateUrl: 'form-submit-button.component.html',
  styleUrls: ['form-submit-button.component.scss'],
  imports: [ButtonComponent, FaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSubmitButtonComponent {
  public readonly form: InputSignal<FieldState<unknown>> = input.required();

  protected readonly faSpinner: IconDefinition = faSpinner;
}
